import L from 'leaflet';
import 'leaflet/dist/leaflet.css';
import * as React from 'react';
// import { memo } from 'react';
import { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import { renderToString } from 'react-dom/server';
import { FaMapMarkerAlt } from 'react-icons/fa';
import { RiMapPinAddFill } from 'react-icons/ri';
import { GiPlainCircle } from 'react-icons/gi';
import {
  MapContainer,
  Marker,
  Polyline,
  Popup,
  TileLayer,
  Tooltip,
  Circle,
  LayersControl,
  ZoomControl,
	// useMap,
	// AttributionControl
} from 'react-leaflet';
import string from 'util/string';
import { formatDate, durationFromNow, nNU } from 'util/utils';
import hazardTiles from 'util/hazardTiles';
import './Map.scss';
// import { Button } from 'react-bootstrap';
// import { BsChevronRight, BsChevronDown } from 'react-icons/bs';
import DkSf03wtIcon from './DkSf03wtIcon';
import DkSf03wt2Icon from './DkSf03wt2Icon';
import DkSf07Icon from './DkSf07Icon';
// import Signal from './Signal';
// import { over } from 'lodash';
// import Control from 'react-leaflet-custom-control';
// import { ThemeConsumer } from 'react-bootstrap/esm/ThemeProvider';
import MapButton from './MapButton';
import MapButton2 from './MapButton2';


export const DEVICE_DEFAULT_LOCATION = [34.683827297666255, 135.50926847102798];

const MAP_DEFAULT_STATE = {
  markerCount: 0,
  minLat: 90,
  maxLat: -90,
  minLng: 180,
  maxLng: -180,
  avgLat: DEVICE_DEFAULT_LOCATION[0],
  avgLng: DEVICE_DEFAULT_LOCATION[1],
};
const ICON_BLINK_INTERVAL = 20;
// const htmlIcon = L.divIcon({
//   className: '_map-marker danger',
//   // iconAnchor: [0, 24],
//   // labelAnchor: [-6, 0],
//   // popupAnchor: [0, -36],
//   iconAnchor: [17, 33],f`
//   iconSize: [35, 46],
//   popupAnchor: [0, -30],
//   html: renderToString(<FaMapMarkerAlt />),
// });

// const HazardButton = () => {
// 	const map = useMap();
// 	useEffect(() => {
//     if (!map) return;

//     const buttonControl = L.control({
//       position: "topleft",
//     });

//     buttonControl.onAdd = function (map) {
//       this._button = L.DomUtil.create("button", "");
//       const buttonElement = `<button class="btn btn-primary">ハザードマップ </button>`;
//       // this._button.innerHTML = buttonElement;
// 			this._button.innerHTML = "test";
// 			this._button.addEventListener("click", () => {
// 				console.log("Clicked");
// 			});
//       return this._button;
//     };

//     buttonControl.addTo(map);

//     return () => {
//       map.remove(buttonControl);
//     };

// 	},[map]);

// 	return null;
// };

const Map = ({
	assetName = null,
	sigfoxId = null,
  data = [],
  geoData = [],
  selectedMarker = null,
  geoSelectedMarker = null,
  MarkerContent,
  GeoMarkerContent,
  zoom,
	maxZoom = 19,
  scrollWheelZoom = true,
  draggable = false,
  onDragEnd = () => {},
  showRoutes = false,
  isJourney = false,
  isCircle = false,
  isClick = false,
  state,
  onSelectedData,
  addGeoData = null,
  isChangedIcon = false,
  isAnimatedIcon = false,
  isGeoDataShow = false,
  isGeoChangedIcon = false,
  isHazardShowed = false,
  isHazardMap = false,
	MarkerBlink = [],
	blinkOff = false,
	satelliteMap = false,
	isGPSDevice = false,
	isDetailMap = false,
  //isChangedIcon = () => {},
}) => {
	// console.log('Re-render');

  const [map, setMap] = useState(null);
	const [buttonAdded, setButtonAdded] = useState(false);
  //const [selectedData, setSelectedData] = useState(addGeoData);
  const markerRefs = useRef([]);
  const geoMarkerRefs = useRef([]);
  const [hazardActive, setHazardActive] = useState(0);
	const [hazardLayerChecked, setHazardLayerChecked] = useState([]);
	const [allHazardLayerChecked, setAllHazardLayerChecked] = useState();
	const [isSatelliteMap, setIsSatelliteMap] = useState(false);

	//const [userAgent, setUserAgent] = useState(null);
	//useEffect(() => {},[]);
	const userAgent = window.navigator.userAgent;
	const isMobileDevice = userAgent.includes('Phone') ||
												 userAgent.includes('Android') ||
												 userAgent.includes('iPad') ?
												 true : false;

  // console.log(data);
  const eventHandlers = useCallback(
    (index) => ({
      dragend() {
        const marker = markerRefs.current[index];
        if (marker !== null) {
          onDragEnd(index, marker.getLatLng());
        }
      },
    }),
    [onDragEnd]
  );

  const geoEventHandlers = useCallback(
    (index) => ({
      dragend() {
        const geoMarker = geoMarkerRefs.current[index];
        if (geoMarker !== null) {
          onDragEnd(index, geoMarker.getLatLng());
        }
      },
    }),
    [onDragEnd]
  );

  const filteredData = useMemo(
    () =>
      data.map((e, index) => ({ ...e, index })).filter((e) => !!e?.location),
    [data]
  );

  const handleClick = (active) => {
    if(active === 0){
      setHazardActive(1);
    }
    else{
      setHazardActive(0);
    }
  };

	const [hazardButtonClicked, setHazardButtonClicked] = useState(false);
	const HazardButton = (active = 0) => {
		useEffect(() => {
			if (!map) return;
			if (buttonAdded === true) return;
			const buttonControl = L.control({
				position: "topleft",
			});
			// let activeChanged = false;
			buttonControl.onAdd = function (map) {
				this._div = L.DomUtil.create("div", "");
				const buttonElement =
					`<div class="btnWrapper">
						<button class="btn btn-primary">
							ハザードマップ
							<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-chevron-right" viewBox="0 0 16 16">
								<path fill-rule="evenodd" d="M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z"/>
							</svg>
						</button>
					</div>`;
				const buttonElement2 =
					`<div class="btnWrapper">
						<button class="btn btn-primary">
							ハザードマップ
							<svg xmlns="http://www.w3.org/2000/svg"width="16" height="16" fill="currentColor" class="bi bi-chevron-down" viewBox="0 0 16 16">
								<path fill-rule="evenodd" d="M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z"/>
							</svg>
						</button>
					</div>`;
				this._div.innerHTML = active === 0 ? buttonElement : buttonElement2;
				this._div.addEventListener("click", () => {
					// handleClick(hazardActive);
					// console.log("hazardActive:", hazardActive);
					if (hazardButtonClicked === false) {
						setHazardButtonClicked(true);
					}
					console.log("hazardActive:", hazardActive);
				});

				return this._div;

				// this._button = L.DomUtil.create("button", "btn btn-primary");
				// // const buttonElement = `<button class="btn btn-primary">ハザードマップ </button>`;
				// // this._button.innerHTML = buttonElement;
				// this._button.innerHTML = "ハザードマップ";
				// this._button.addEventListener("click", () => {
				// 	// handleClick(hazardActive);
				// 	// console.log("hazardActive:", hazardActive);
				// 	if (hazardButtonClicked === false) {
				// 		setHazardButtonClicked(true);
				// 	}
				// 	// console.log("hazardActive:", hazardActive);
				// });
				// return this._button;
			};

			if (buttonAdded === false) {
				buttonControl.addTo(map);
				setButtonAdded(true);
			}
			/* eslint-disable react-hooks/exhaustive-deps */
		},[map]);

		return null;
	};
	useEffect(() =>{
		if (hazardButtonClicked === true){
			// console.log("hazardActive:", hazardActive);
			handleClick(hazardActive);
			setTimeout(() => setHazardButtonClicked(false),0);
			// setTimeout(() => setButtonAdded(false),0);
		}
	},[hazardButtonClicked]);

	const [mapButtonClicked,setMapButtonClicked] = useState(false);
	useEffect(() =>{
		if (mapButtonClicked === true){
			// console.log("hazardActive:", hazardActive);
			// handleClick(hazardActive);
			setIsSatelliteMap(!isSatelliteMap);
			if (isClick === false){
				setTimeout(() => setMapButtonClicked(false),0);
			}
			// setTimeout(() => setButtonAdded(false),0);
		}
	},[mapButtonClicked]);

	// useEffect(()=>{
	// 	if(hazardActive === 0){
	// 		console.log("rerender");
	// 	}
	// },[hazardActive]);

	const handleAllTileLayerAdd = () => {
		setAllHazardLayerChecked(true);
		let hazardChecked = [...hazardLayerChecked];
		for(let i = 0; i < hazardTiles.length; i++){
			hazardChecked[i] = true;
		}
		setHazardLayerChecked(hazardChecked);
	};

	const handleAllTileLayerRemove = () => {
		setAllHazardLayerChecked(false);
		let hazardChecked = [...hazardLayerChecked];
		let allChecked = true;
		for(let i = 0; i < hazardTiles.length; i++){
			if(hazardChecked[i] === false){
				allChecked = false;
				break;
			}
		}
		if(allChecked === true){
			for(let i = 0; i < hazardTiles.length; i++){
				hazardChecked[i] = false;
			}
			setHazardLayerChecked(hazardChecked);
		}
	};

	const handleTileLayerAdd = (url) =>{
		let hazardChecked = [...hazardLayerChecked];
		for(let i = 0; i < hazardTiles.length; i++){
			if(hazardTiles[i].url === url){
				hazardChecked[i] = true;
				break;
			}
		}
		setHazardLayerChecked(hazardChecked);
		let enableAll = true;
		for(let i = 0; i < hazardTiles.length; i++){
			if(hazardChecked[i] === false){
				enableAll = false;
				break;
			}
		}
		setAllHazardLayerChecked(enableAll);
	};

	const handleTileLayerRemove = (url) =>{
		let hazardChecked = [...hazardLayerChecked];
		for(let i = 0; i < hazardTiles.length; i++){
			if(hazardTiles[i].url === url){
				hazardChecked[i] = false;
				break;
			}
		}
		setHazardLayerChecked(hazardChecked);
		setAllHazardLayerChecked(false);
	};

	useEffect(() => {
		if (!nNU(map)){
			return;
		}
		if(!nNU(hazardLayerChecked)){
			return;
		}
		localStorage.setItem('HazardCheck', JSON.stringify(hazardLayerChecked));
    /* eslint-disable react-hooks/exhaustive-deps */
	},[hazardLayerChecked]);

	useEffect(() => {
		let hazardChecked = [];
		if(nNU(localStorage.getItem('HazardCheck'))){
			hazardChecked = JSON.parse(localStorage.getItem('HazardCheck'));
		}
		else{
			hazardTiles.map((tile) => (
				hazardChecked = [...hazardChecked,tile.checked]
			));
		}
		setHazardLayerChecked(hazardChecked);
		// console.log(hazardLayerChecked);
    /* eslint-disable react-hooks/exhaustive-deps */
	},[]);

  useEffect(() => {
    if (
      nNU(selectedMarker) &&
      !!map &&
      !!markerRefs?.current?.[selectedMarker]
    ) {
      map.closePopup();
      let curMarker = markerRefs.current[selectedMarker];
      map.setView(map.getCenter(), map.getZoom(), { animate: false });
      //map.setView(map.getCenter(), map.getZoom(), { animate: true });
      map.panTo(curMarker.getLatLng());
      setTimeout(() => {
        curMarker.openPopup();
      }, 300);
    }
  }, [selectedMarker, map]);

  useEffect(() => {
    if (
      nNU(geoSelectedMarker) &&
      !!map &&
      !!geoMarkerRefs?.current?.[geoSelectedMarker]
    ) {
      map.closePopup();
      let curMarker = geoMarkerRefs.current[geoSelectedMarker];
      map.setView(map.getCenter(), map.getZoom(), { animate: false });
      map.panTo(curMarker.getLatLng());
      setTimeout(() => {
        curMarker.openPopup();
      }, 300);
    }
  }, [geoSelectedMarker, map]);

	const [mapClicked, setMapClicked] = useState(false);
	const [mapClickedPos, setMapClickedPos] = useState();
  useEffect(() => {
    if (!map || map?.bindDone === true) {
      return;
    }
    L.control.scale().addTo(map);
    map.on('popupopen', (e) => {
      if (!!e?.popup?._source?._tooltip?.setOpacity) {
        e.popup._source._tooltip.setOpacity(0.0);
      }
    });
    map.on('popupclose', (e) => {
      if (!!e?.popup?._source?._tooltip?.setOpacity) {
        e.popup._source._tooltip.setOpacity(0.9);
      }
    });
    if (isClick) {
			map.on('click', (e) => {
				//setTimeout(() => {handleMapClicked(e)},100);
				// if (mapButtonClicked === false) {
				// 	//setSelectedData(e);
				// 	onSelectedData(e);
				// }
				setMapClicked(true);
				setMapClickedPos(e);
			});
    }

    map.attributionControl.setPrefix(
			''
      // `<a href="https://leafletjs.com" title="A JavaScript library for interactive maps">Leaflet</a>`
    );
    map.bindDone = true;
		/* eslint-disable react-hooks/exhaustive-deps */
  }, [map]);

	useEffect(() => {
		if (mapClicked === true){
			handleMapClicked(mapClickedPos);
		}
		setTimeout(() =>setMapClicked(false), 0);
	},[mapClicked,mapClickedPos]);
	const handleMapClicked = (e) => {
		if (mapButtonClicked === false) {
			//setSelectedData(e);
			onSelectedData(e);
		}
		else{
			setTimeout(() => setMapButtonClicked(false),0);
		}
	};


  const [mapStats, setMapStats] = useState(MAP_DEFAULT_STATE);
  useEffect(() => {
    let tempData = filteredData.reduce(
      (c, e) => {
        let [lat, lng] = e.location;
        return {
          ...c,
          minLat: Math.min(c.minLat, lat),
          maxLat: Math.max(c.maxLat, lat),
          minLng: Math.min(c.minLng, lng),
          maxLng: Math.max(c.maxLng, lng),
        };
      },
      {
        ...MAP_DEFAULT_STATE,
        markerCount: filteredData.length,
      }
    );
    if (!!filteredData?.length) {
      // tempData.avgLat = (tempData.maxLat + tempData.minLat) / 2;
      // tempData.avgLng = (tempData.maxLng + tempData.minLng) / 2;
      tempData.avgLat = filteredData[0].location[0];
      tempData.avgLng = filteredData[0].location[1];
    }

    setMapStats(tempData);
  }, [filteredData]);

  const markerCount = useRef(0);
  useEffect(() => {
    if (!!map && markerCount.current !== mapStats.markerCount) {
      markerCount.current = mapStats.markerCount;
      map.setView(map.getCenter(), map.getZoom(), { animate: false });
      map.panTo(new L.LatLng(mapStats.avgLat, mapStats.avgLng));
      // let markersGroup = [];
      // if (markerCount.current > 0) {
      //   markerRefs.current.forEach((marker) => {
      //     let latlngMarker = [];
      //     if (nNU(marker?._latlng.lat) && nNU(marker?._latlng.lng)) {
      //       latlngMarker.push(marker?._latlng.lat, marker?._latlng.lng);
      //       markersGroup.push(latlngMarker);
      //     }
      //   });
      // } else {
      //   markersGroup.push([45.452824, 141.913799], [31.031249, 130.689764]);
      // }
      // map.fitBounds(markersGroup, { maxZoom: 15 });
      // map.setMinZoom(map.getZoom());
    }
  }, [map, mapStats, markerCount]);

  window['map'] = map;
  window['markers'] = markerRefs;
  window['geoMarkers'] = geoMarkerRefs;
  window['L'] = L;

  // useEffect(() => {
  //   if (!nNU(map)) return;
  //   // if (!nNU(localStorage.getItem('Map'))) return;
  //   let data = map.getZoom();
  //   let dataLocalStorage = !nNU(localStorage.getItem('Map'))
  //     ? 8
  //     : JSON.parse(localStorage.getItem('Map'));
  //   if (data === dataLocalStorage) return;
  //   map.setZoom(data);
  //   localStorage.setItem('Map', JSON.stringify(data));
  //   // nNU(data) && localStorage.setItem('Map', JSON.stringify(data));
  // }, [map, mapStats, markerCount, zoom]);

  useEffect(() => {
    if (!nNU(map)) return;
    map.on('zoomend', (e) => {
      // console.log(e.target._zoom);
      let data = e.target._zoom;
      let dataLocalStorage = !nNU(localStorage.getItem('Map'))
        ? 8
        : JSON.parse(localStorage.getItem('Map'));
      if (data === dataLocalStorage) return;
      map.setZoom(data);
      localStorage.setItem('Map', JSON.stringify(data));
    });
  }, [map, zoom]);

	const [blinkCountdown, setBlinkCountdown] = useState([]);
	const [markerInvisible, setMarkerInvisible] = useState(false);

	useEffect(() => {
		let newBlinkCountdown = blinkCountdown;
		if(!nNU(MarkerBlink)){
			newBlinkCountdown = [];
		}
		else if(newBlinkCountdown.length !== MarkerBlink.length){
			newBlinkCountdown = MarkerBlink;
		}
		else{
			for(let i = 0; i < MarkerBlink.length; i++){
				if(MarkerBlink[i] > 0){
					newBlinkCountdown[i] = MarkerBlink[i];
				}
			}
		}
		setBlinkCountdown(newBlinkCountdown);
	},[MarkerBlink]);

	useEffect(() => {
		const timerId = setTimeout(() => {
			setMarkerInvisible(!markerInvisible);
			let newBlinkCountdown = blinkCountdown;
			for(let i = 0; i < newBlinkCountdown.length; i++){
				if(newBlinkCountdown[i] > 0){
					newBlinkCountdown[i] = newBlinkCountdown[i] - 1;
				}
			}
			setBlinkCountdown(newBlinkCountdown);
		},500);

		return () => clearTimeout(timerId);
	},[markerInvisible, blinkCountdown]);


  return (
    <>
			{/* {!!isHazardShowed && (
				<Button
					color='inherit'
					onClick={()=>handleClick(hazardActive)}
					size='sm'
					// display='flex'
					style={{
						padding:'2px',
						margin:'5px',
					}}
				>
					{'ハザードマップ '}{hazardActive === 1 ? <BsChevronDown />:<BsChevronRight/>}
				</Button>
			)} */}
      <MapContainer
        center={[mapStats?.avgLat, mapStats?.avgLng]}
        // zoom={!isHazardShowed && !isHazardMap && (zoom < 5) ? 5 : zoom}
				zoom={!!isHazardShowed ? zoom :
					!!isSatelliteMap ?
						(zoom < 9) ? 9 :
							(zoom > 18) ? 18 : zoom :
					(zoom < 5) ? 5 : zoom }
        zoomControl={false}
        scrollWheelZoom={scrollWheelZoom}
        whenCreated={setMap}
				// attributionControl={false}
      >
        {!isHazardShowed && !isHazardMap && (maxZoom < 20) && (<TileLayer
          maxZoom={maxZoom}
          attribution='&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
          url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
          // url="https://tile.thunderforest.com/cycle/{z}/{x}/{y}.png?apikey=4311b7d528e943e6bfc57c6afa16639b"
          // url="https://tile.thunderforest.com/landscape/{z}/{x}/{y}.png?apikey=4311b7d528e943e6bfc57c6afa16639b"
          // url="https://tile.thunderforest.com/mobile-atlas/{z}/{x}/{y}.png?apikey=4311b7d528e943e6bfc57c6afa16639b"
        />)}
        {!isHazardShowed && !isHazardMap && !isSatelliteMap && (maxZoom > 19) && (<TileLayer
          maxZoom={maxZoom}
          attribution='Maps &copy; <a href="https://www.thunderforest.com/">Thunderforest</a>, Data &copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
          // url = "https://cyberjapandata.gsi.go.jp/xyz/seamlessphoto/{z}/{x}/{y}.jpg"
					// url = "http://mt.google.com/vt/lyrs=s&hl=en&x={x}&y={y}&z={z}"
					// url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"

					// url="https://tile.thunderforest.com/landscape/{z}/{x}/{y}.png?apikey=4311b7d528e943e6bfc57c6afa16639b"
          url="https://tile.thunderforest.com/transport/{z}/{x}/{y}.png?apikey=4311b7d528e943e6bfc57c6afa16639b"
          // url="https://tile.thunderforest.com/cycle/{z}/{x}/{y}.png?apikey=4311b7d528e943e6bfc57c6afa16639b"
          // url="https://tile.thunderforest.com/mobile-atlas/{z}/{x}/{y}.png?apikey=4311b7d528e943e6bfc57c6afa16639b"
        />)}
        {!isHazardShowed && !isHazardMap && !!isSatelliteMap && (maxZoom > 19) && (<TileLayer
          minZoom={9}
          maxZoom={18} // ハザードマップポータルサイトのデータの最大ズームレベル

          // attribution='&copy; <a href="https://maps.gsi.go.jp/development/ichiran.html">国土地理院</a>'
          attribution='<a href="https://maps.gsi.go.jp/development/ichiran.html">出典：国土地理院ウェブサイトへ</a>'
          url = "https://cyberjapandata.gsi.go.jp/xyz/seamlessphoto/{z}/{x}/{y}.jpg"
        />)}
        {(!!isHazardShowed || !!isHazardMap) && (<TileLayer
          minZoom={5}
          maxZoom={18} // ハザードマップポータルサイトのデータの最大ズームレベル

          // attribution='&copy; <a href="https://maps.gsi.go.jp/development/ichiran.html">国土地理院</a>'
          attribution='<a href="https://maps.gsi.go.jp/development/ichiran.html">出典：国土地理院ウェブサイトへ</a>'
          //url="https://cyberjapandata.gsi.go.jp/xyz/pale/{z}/{x}/{y}.png"
          url="https://cyberjapandata.gsi.go.jp/xyz/pale/{z}/{x}/{y}.png"
        />)}
				{/* <AttributionControl
					position="bottomright"
					prefix={false}
					// prefix={'<a href="https://leafletjs.com" title="A JavaScript library for interactive maps">Leaflet</a>'}
				/> */}
				{/* {!!isHazardShowed && (
					<Description
						color='inherit'
						title='ハザードマップ'
						onClick={()=>handleClick(hazardActive)}
						size='sm'
						// display='flex'
						style={{
							padding:'2px',
							margin:'5px',
						}}
					>
						{'ハザードマップ '}{hazardActive === 1 ? <BsChevronDown />:<BsChevronRight/>}
					</Description>
				)} */}

				{!!isHazardShowed && (
					<MapButton
						active = {hazardActive}
						handleOnClick={()=>{
							if (hazardButtonClicked === false) {
								setHazardButtonClicked(true);
							}
						}}
						// onClick={handleClick(hazardActive)}
					/>
				)}

				{!isHazardShowed && !!isGPSDevice && (
					<MapButton2
						active = {isSatelliteMap}
						handleOnClick={()=>{
							if (mapButtonClicked === false) {
								setMapButtonClicked(true);
							}
						}}
						// onClick={handleClick(hazardActive)}
					/>
				)}
				{/* {!!isHazardShowed && (
					<HazardButton
						active = {hazardActive}
					/>
				)} */}
				{/* {!!isHazardShowed && (hazardActive === 1) && (<HazardButton2	/>)} */}
				{/* {!!isHazardShowed && (
					<Button
						color='inherit'
						onClick={()=>handleClick(hazardActive)}
						size='sm'
						// display='flex'
						style={{
							padding:'2px',
							margin:'5px',
						}}
					>
						{'ハザードマップ '}{hazardActive === 1 ? <BsChevronDown />:<BsChevronRight/>}
					</Button>
				)} */}
        <ZoomControl
          position={!!isHazardShowed ? 'topright' :
										!!isGPSDevice ? 'topright':'topleft'}
        />

        {!!isHazardShowed && nNU(hazardActive) && (hazardActive === 1) && (
          <LayersControl
            position='topleft'
						collapsed={false}
					>
						<LayersControl.Overlay
							key={'ALL'}
							name={'全選択'}
							checked={allHazardLayerChecked}
						>
							<TileLayer
								url={'selectAll'}
								opacity={0}
								eventHandlers={{
									add: () => {
										//console.log("Layer added:",e.target._url);
										// handleTileLayerAdd(e.target._url);
										handleAllTileLayerAdd();
									},
									remove: () => {
										//console.log("Layer removed:",e.target._url);
										// handleTileLayerRemove(e.target._url);
										handleAllTileLayerRemove();
									}
								}}
							></TileLayer>
						</LayersControl.Overlay>
            {hazardTiles.map((tile, index) =>(
              <LayersControl.Overlay
                //key={tile.name}
								key={index}
                name={tile.name}
								checked={hazardLayerChecked[index]}
                //checked={hazardLayerChecked[index] || tile.checked}
							>
                <TileLayer
									// key={index}
                  url={tile.url}
                  opacity={tile.opacity || 0.75}
									//opacity={0}
                  attribution={tile.attribution}
									eventHandlers={{
										add: (e) => {
											//console.log("Layer added:",e.target._url);
											handleTileLayerAdd(e.target._url);
										},
										remove: (e) => {
											//console.log("Layer removed:",e.target._url);
											handleTileLayerRemove(e.target._url);
										}
									}}
                />
              </LayersControl.Overlay>
            ))}
          </LayersControl>
          )
        }

				{ !!isHazardShowed && nNU(hazardActive) && (hazardActive === 0) && (
					<>
            {hazardTiles.map((tile, index) =>(hazardLayerChecked[index] &&
							<TileLayer
								// key={index}
								url={tile.url}
								opacity={tile.opacity || 0.75}
								attribution={tile.attribution}
							/>
						))}
					</>
				)}

        {data.map((markerData, index) => {
          //console.log(markerData);
          if (!showRoutes && !nNU(markerData.model)) return null;
					let duration = 100;
					if(nNU(markerData?.dataLogTime)){
						let logDate = new Date(formatDate(markerData?.dataLogTime,"YYYY-MM-DDTHH:mm:ss"));
						duration = durationFromNow(logDate);
						// console.log('Duration: ', duration);
					}
					let dipSwitch =
            nNU(markerData?.dipSwitch) ? parseInt(`0x${markerData?.dipSwitch}`):0;
					let timeout = (duration > 1) && ((dipSwitch & parseInt('0x0008')) > 0) ? 1:0;
					let singleSensor =
            (dipSwitch & parseInt('0x0010')) > 0 ? 1:0;
          let flood =
						nNU(markerData?.notifyType) && (markerData?.notifyType === '17') ? 0 :
            	nNU(markerData?.dataType1) ?
            		singleSensor > 0 ? parseInt(markerData?.dataType1) % 2:parseInt(markerData?.dataType1) % 4:0;
          let tilt =
            nNU(markerData?.model) && (markerData?.model === string.DEVICE_SF07) ?
							(nNU(markerData?.dataType7) && (markerData?.dataType7.toUpperCase() === '00') ? 1 : 0)
						: nNU(markerData?.model) && (markerData?.model === string.DEVICE_SF03WT2) ?
							(nNU(markerData?.dataType3) && (markerData?.dataType3 === '1') ? 1:0) : 0;
          let batteryLow =
            nNU(markerData?.batteryVoltage) && parseFloat(markerData?.batteryVoltage) > 2.4 ? 0:1;
					let dataValid =
						nNU(markerData?.notifyType) && nNU(markerData?.dataType1) ? true:false;

          return (
            <Marker
              draggable={draggable || !!markerData?.draggable}
              key={index}
              // opacity={!markerData?.location?.length ? 0 : 1}
              opacity={
								nNU(blinkOff) && nNU(MarkerBlink) && nNU(MarkerBlink[index]) && (MarkerBlink[index] > 0) && blinkOff ? 0 :
								!markerData?.location?.length ? 0 : 1
							}
              // opacity={
							// 	markerInvisible && nNU(blinkCountdown) && nNU(blinkCountdown[index]) && (blinkCountdown[index] > 0) ? 0 :
							// 	!markerData?.location?.length ? 0 : 1
							// }
							// opacity={
							// 	nNU(MarkerBlink) && nNU(MarkerBlink[index]) && MarkerBlink[index] ? 0 :
							// 	!markerData?.location?.length ? 0 : 1
							// }
              position={markerData?.location || [0, 0]}
              icon={L.divIcon({
                className: (isDetailMap === true) ? (`_detail-map-marker ${
                  markerData.model === string.DEVICE_WBGT
                    ? state?.[markerData.deviceId] || 'normal'
                    : ''
                } ${
                    markerData.model === string.DEVICE_SF03WT ? '':
                      markerData.model === string.DEVICE_SF03WT2 ? '':
	                      markerData.model === string.DEVICE_SF07 ? '':
  	                      isChangedIcon ? '': 'icon'
                  }`):(`_map-marker ${
										markerData.model === string.DEVICE_WBGT
											? state?.[markerData.deviceId] || 'normal'
											: ''
									} ${
											markerData.model === string.DEVICE_SF03WT ? '':
												markerData.model === string.DEVICE_SF03WT2 ? '':
													markerData.model === string.DEVICE_SF07 ? '':
														isChangedIcon ? '': 'icon'
										}`),
                iconAnchor:
                  markerData.model === string.DEVICE_SF03WT ?
                    ([0, 18]):
                      markerData.model === string.DEVICE_SF03WT2 ?
                      ([0, 18]):
												markerData.model === string.DEVICE_SF07 ?
												([0, 18]):
													isChangedIcon ? [8, 12] : [17, 33],
                iconSize:
                  markerData.model === string.DEVICE_SF03WT ?
                    ([40, 45]):
                      markerData.model === string.DEVICE_SF03WT2 ?
                      ([40, 45]):
												markerData.model === string.DEVICE_SF07 ?
												([40, 45]):
													isChangedIcon ? [15, 15] : [35, 46],
                popupAnchor:
                  markerData.model === string.DEVICE_SF03WT ?
                    ([20, -18]):
                      markerData.model === string.DEVICE_SF03WT2 ?
                      ([20, -18]):
												markerData.model === string.DEVICE_SF07 ?
												([20, -18]):
													isChangedIcon ? [0, 0] : [0, -30],
                html: renderToString(
                  (markerData.model === string.DEVICE_SF03WT2 ?
										dataValid ?
                    ((singleSensor === 1) ?
                      <DkSf03wtIcon
                        timeout={timeout}
                        flood={flood}
                        tilt={tilt}
                        batteryLow={batteryLow}
                      /> :
                      <DkSf03wt2Icon
                        timeout={timeout}
                        flood={flood}
                        tilt={tilt}
                        batteryLow={batteryLow}
                      />
                    ):(null)
										:markerData.model === string.DEVICE_SF07 ? (
											<DkSf07Icon
												tilt={tilt}
											/>)
										:(isChangedIcon ? <GiPlainCircle /> : <FaMapMarkerAlt />))
                ),
              })}
              ref={(markerElm) => (markerRefs.current[index] = markerElm)}
              eventHandlers={eventHandlers(index)}
            >
              {/*<SvgComponent/>*/}
              {!!MarkerContent && ((markerData.model !== string.DEVICE_SF03WT2) || dataValid) && (
                <>
                  <Popup>
                    <MarkerContent
											data={markerData}
											isJourney={isJourney}
											assetName={assetName}
											sigfoxId={sigfoxId}
											isClickable={true}
										/>
                  </Popup>
                  {!isMobileDevice && (<Tooltip>
                    <MarkerContent
											data={markerData}
											isJourney={isJourney}
											assetName={assetName}
											sigfoxId={sigfoxId}
											isClickable={false}
										/>
                  </Tooltip>)}
                </>
              )}
            </Marker>
          );
        })}
        {geoData.map((markerData, index) => {
          //console.log(markerData);
          if (!isGeoChangedIcon) return null;
          return (
            <Marker
              draggable={draggable || !!markerData?.draggable}
              key={index}
              opacity={!markerData?.location?.length ? 0 : 1}
              position={markerData?.location || [0, 0]}
              icon={L.divIcon({
                className: `_geo-map-marker ${
                  markerData.model === string.DEVICE_WBGT
                    ? state?.[markerData.deviceId] || 'normal' :
                    markerData.model === string.DEVICE_SFGPS ? ''
                    : ''
                } ${isGeoChangedIcon ? '' : 'icon'}`,
                iconAnchor: isGeoChangedIcon ? [8, 12] : [17, 33],
                iconSize: isGeoChangedIcon ? [30, 30] : [35, 46],
                popupAnchor: isGeoChangedIcon ? [0, 0] : [0, -30],
                html: renderToString(
                  isGeoChangedIcon ? <GiPlainCircle /> : <FaMapMarkerAlt />
                ),
              })}
              ref={(markerElm) => (geoMarkerRefs.current[index] = markerElm)}
              //ref={(markerElm) => (markerRefs.current[index] = markerElm)}
              eventHandlers={geoEventHandlers(index)}
            >
              {!!GeoMarkerContent && (
                <>
                  <Popup>
                    <GeoMarkerContent data={markerData} isJourney={false} />
                  </Popup>
                  {!isMobileDevice && (<Tooltip>
                    <GeoMarkerContent data={markerData} isJourney={false} />
                  </Tooltip>)}
                </>
              )}
            </Marker>
          );
        })}
        {addGeoData && (
          <Marker
            //draggable={draggable}
            opacity={1}
            position={
              [addGeoData?.latlng?.lat, addGeoData?.latlng?.lng] || [0, 0]
            }
            icon={L.divIcon({
              className: `_map-marker`,
              iconAnchor: [17, 23],
              iconSize: [25, 25],
              popupAnchor: [0, -30],
              html: renderToString(<RiMapPinAddFill />),
            })}
            // ref={(markerElm) => (markerRefs.current[index] = markerElm)}
            // eventHandlers={eventHandlers(index)}
          ></Marker>
        )}
        {/*isCircle &&
          data.map((markerData) => {
            if (!nNU(markerData.location)) return null;
            // if (markerData.model !== string.DEVICE_SFGPS) return null;
            if (!nNU(markerData.radius) || (markerData.radius < 1)) return null;
            return (
              <Circle
                center={[markerData.location[0], markerData.location[1]]}
                radius={markerData.radius}
              ></Circle>
            );
          })*/}
        {isCircle &&
          geoData.map((markerData) => {
            if (!nNU(markerData.location)) return null;
            // if (markerData.model !== string.DEVICE_SFGPS) return null;
            if (!nNU(markerData.radius) || (markerData.radius < 1)) return null;
            return (
              <Circle
                center={[markerData.location[0], markerData.location[1]]}
                radius={markerData.radius}
              ></Circle>
            );
          })}
        {showRoutes &&
          data
            .filter((e, i) => i < data.length - 1)
            .map((markerData, index) => (
              <Polyline
                key={index}
                positions={[markerData?.location, data[index + 1]?.location]}
              />
            ))
        }
      </MapContainer>
    </>
  );
};

export default Map;
// export default memo(Map);
